import { Col, Form, InputNumber } from 'antd'
import React from 'react'

const ExtrutionFields = ({ prefix }) => {
  return (
    <>
      <Col xs={24} md={6}>
        <Form.Item
          label="Part Weight/Meter"
          name={[prefix, "part_weight"]}
          rules={[
            {
              required: true,
              message: "Please input Part weight/meter...!",
            },
          ]}
        >
          <InputNumber
            addonAfter="gm/meter"
            defaultValue={0}
            placeholder="Part Weight/Meter"
            precision={2}
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          label="Machine Speed"
          name={[prefix, "machine_speed"]}
        >
          <InputNumber
            defaultValue={0}
            placeholder="Machine Speed"
            precision={0}
            addonAfter="meter/min"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
    </>
  )
}

export default ExtrutionFields